// extracted by mini-css-extract-plugin
export default {"accordionSummary":"NavSection_accordionSummary__GbV5T","accordion":"NavSection_accordion__7faAr","accordionDetails":"NavSection_accordionDetails__HkplV"};